import {
  CustomerDeliverabilityEngineQueryParams,
  IntelligentAssistantEvents,
} from "../definitions/constants";

export const hasCdeErrorCodeParams = (queryString: string): boolean => {
  if (queryString) {
    const searchParams = new URLSearchParams(decodeURIComponent(queryString));
    const cdeErrorCode = searchParams.get(
      CustomerDeliverabilityEngineQueryParams.CDE_ERROR_CODE
    );
    const cdeErrorCodeName = searchParams.get(
      CustomerDeliverabilityEngineQueryParams.CDE_ERROR_CODE_NAME
    );

    if (cdeErrorCode && cdeErrorCodeName) {
      return true;
    }
  }

  return false;
};

export const intelligentAssistantEventHandlerMap = {
  [IntelligentAssistantEvents.SESSION_STORAGE_CHANGE]: () => {
    return;
  },
};
